import React, { PropsWithChildren } from 'react'

import { blockquoteParagraph, blockquote } from './index.module.scss'

const BlockquoteBlock = ({ children }: PropsWithChildren<{}>) => {
  const paragraphs = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      // `child` is a ParagraphBlock with its content as `children`. Here we're exchanging this
      // ParagraphBlock with a simple <p> so that we can set a different className
      return <p className={blockquoteParagraph}>{child.props.children}</p>
    }
    return child
  })

  return <blockquote className={blockquote}>{paragraphs}</blockquote>
}

export default BlockquoteBlock
